import React from 'react';

function HowToEngage({ platformDescription, consultingDescription }) {
  return (
    <>
      <div className="mb-16">
        <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-6 text-center">How to engage</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-200 rounded-lg p-8 hover:border-gray-300 transition-colors flex flex-col">
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3">Self-serve platform</div>
            <h3 className="text-xl font-medium text-gray-900 mb-3">Build your own models</h3>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow">{platformDescription}</p>
            <a href="https://app.veydra.io" className="mt-auto"><button className="w-full border border-gray-900 text-gray-900 px-6 py-3 rounded text-sm font-medium hover:bg-gray-900 hover:text-white transition-colors">Start with the platform →</button></a>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-8 hover:border-gray-300 transition-colors flex flex-col">
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3">Expert-led engagement</div>
            <h3 className="text-xl font-medium text-gray-900 mb-3">Work with our team</h3>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow">{consultingDescription}</p>
            <a href="/contact" className="mt-auto"><button className="w-full border border-gray-900 text-gray-900 px-6 py-3 rounded text-sm font-medium hover:bg-gray-900 hover:text-white transition-colors">Schedule a conversation →</button></a>
            </div>
        </div>
      </div>
    </>
  );
}

export default HowToEngage;
